import Highlight from 'components/Highlight';

const APPLICANT_AT_FIRM_CLASS = 'applicant-at-firm';
const NAME_FIRM_SEPARATOR = ' @ ';
const EMPTY_VALUE_PLACEHOLDER = '-';

/**
 * Renders the applicant name and firm name of a filing row as "Name @ Firm",
 * falling back to whichever part is present. The active search term is marked
 * inside each part; Highlight no-ops when substring is empty or undefined, so
 * the rendering with no active search is unchanged.
 */
function ApplicantAtFirm(props) {
	const { rowData, searchString } = props;
	const firstName = (rowData?.applicant_first_name || '').trim();
	const lastName = (rowData?.applicant_last_name || '').trim();
	const firmName = (rowData?.firm_name || '').trim();

	const fullName = [firstName, lastName].filter(Boolean).join(' ');

	if (fullName && firmName) {
		return (
			<span className={APPLICANT_AT_FIRM_CLASS}>
				<Highlight text={fullName} substring={searchString} />{NAME_FIRM_SEPARATOR}<Highlight text={firmName} substring={searchString} />
			</span>
		);
	}
	if (fullName) {
		return (
			<span className={APPLICANT_AT_FIRM_CLASS}>
				<Highlight text={fullName} substring={searchString} />
			</span>
		);
	}
	if (firmName) {
		return (
			<span className={APPLICANT_AT_FIRM_CLASS}>
				<Highlight text={firmName} substring={searchString} />
			</span>
		);
	}
	return <span className={APPLICANT_AT_FIRM_CLASS}>{EMPTY_VALUE_PLACEHOLDER}</span>;
}

export default ApplicantAtFirm;
